import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import LoadingPage from '../../components/LoadingPage';
import { db } from '../../../config/Fire';
import * as Constants from '../../../constants';
import { getUser } from '../../../reducers';
import Chats from '../../components/Chats';
import './styles.css';

const ChatEmployee = props => {
    const[actualProcedures, setActualProcedures] = useState(null)

    const setListenerForActualProcedures = user => {
        console.log("setListenerForActualProcedures employee")
        if(user.employeeCategories) {
            const employeeCategories = Object.keys(user.employeeCategories);
            db.ref(`${Constants.MAIN_NODES.PROCEDURES}`).orderByChild(`employeeIds/${user.id}`).equalTo(true).on("value", function(snapListener) {
                if(snapListener.exists()) {
                    const proceduresMap = {}
                    snapListener.forEach(procedureSnap => {
                        const procedure = procedureSnap.val();
                        if(employeeCategories.includes(procedure.employeeCategory)) {
                            proceduresMap[procedure.id] = procedure;
                        }
                    });
                    setActualProcedures(proceduresMap)
                } else {
                    setActualProcedures({})
                }
            })
        } else {
            setActualProcedures({})
        }
        return <LoadingPage />
    }

    return (
        <div className="chatEmployeeCont">
            {
                props.user ?
                    actualProcedures !== null ?
                        <Chats procedures={actualProcedures} enableChat={true} />
                        :
                        setListenerForActualProcedures(props.user)
                    :
                    <LoadingPage />
            }
        </div>
    );
};

ChatEmployee.propTypes = {
    
};

const mapDispatchToPropsActions = dispatch => ({
    
});

const mapStateToProps = state => ({ 
    user:  getUser(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(ChatEmployee));